(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gimoka-campaign-countdown"] && !Shopify.designMode) return;
  try {
    
  class GimokaCampaignCountdown {
    constructor(root) {
      root.gimokaCampaignCountdown?.destroy();
      this.root = root;
      this.endTime = new Date(root.dataset.endDate).getTime();
      this.timerElement = root.querySelector('[data-countdown-timer]');
      this.expiredElement = root.querySelector('[data-countdown-expired]');
      this.buttonElement = root.querySelector('[data-countdown-button]');
      this.parts = {
        days: root.querySelector('[data-countdown-days]'),
        hours: root.querySelector('[data-countdown-hours]'),
        minutes: root.querySelector('[data-countdown-minutes]'),
        seconds: root.querySelector('[data-countdown-seconds]'),
      };
      root.gimokaCampaignCountdown = this;
      this.update();

      if (Number.isFinite(this.endTime) && this.endTime > Date.now()) {
        this.interval = window.setInterval(() => this.update(), 1000);
      }
    }

    update() {
      if (!Number.isFinite(this.endTime)) return;

      const remaining = Math.max(0, this.endTime - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
      };

      for (const [key, value] of Object.entries(values)) {
        if (this.parts[key]) this.parts[key].textContent = String(value).padStart(2, '0');
      }

      if (remaining === 0) {
        this.destroy();
        if (this.expiredElement) this.expiredElement.hidden = false;
        if (this.buttonElement) this.buttonElement.hidden = true;
      }
    }

    destroy() {
      if (this.interval) window.clearInterval(this.interval);
    }
  }

  const initializeGimokaCountdowns = (scope = document) => {
    scope.querySelectorAll('[data-gimoka-countdown]').forEach((root) => new GimokaCampaignCountdown(root));
  };

  initializeGimokaCountdowns();
  document.addEventListener('shopify:section:load', (event) => initializeGimokaCountdowns(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelector('[data-gimoka-countdown]')?.gimokaCampaignCountdown?.destroy();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
